const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchVehicles = async ({ limit, offset, query }) => {
    try {
      const response = await fetch(`${API_URL}/vehicle/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ limit, offset, query }),
      });
  
      if (!response.ok) {
        throw new Error('Error al obtener los vehículos');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener los vehículos:', error);
      throw error;
    }
  };

  export const createVehicle = async (vehicleData) => {
    try {
      const response = await fetch(`${API_URL}/vehicle/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(vehicleData),
      });
  
      if (!response.ok) {
        throw new Error('Error al crear el vehículo');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al crear el vehículo:', error);
      throw error;
    }
  };

  export const updateVehicle = async (vehicleId, vehicleData) => {
    try {
      const response = await fetch(`${API_URL}/vehicle/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: vehicleId, data: vehicleData }),
      });
  
      if (!response.ok) {
        throw new Error('Error al actualizar el vehículo');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al actualizar el vehículo:', error);
      throw error;
    }
  };

  export const deleteVehicle = async (vehicleId) => {
    try {
      const response = await fetch(`${API_URL}/vehicle/delete/${vehicleId}`, {
        method: 'DELETE',
      });
  
      if (!response.ok) {
        throw new Error('Error al eliminar el vehículo');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al eliminar el vehículo:', error);
      throw error;
    }
  };

  export const exportVehicles = async (query = {}) => {
    try {
      const response = await fetch(`${API_URL}/vehicle/export`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
      });
  
      if (!response.ok) {
        throw new Error('Error al exportar los vehículos');
      }
  
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error al exportar los vehículos:', error);
      throw error;
    }
  };
